/**
 * API Exception DTO
 */
export interface APIException {
    name: string;
    message: string;
    stack?: string;
    code?: any;
    exceptions: ExceptionDto[];
}

export interface ExceptionDto {
    code: string;
    message: string;
    exceptionDetail: string;
    field: string;
    errorDisplayType: 'GLOBAL' | 'FIELD';
    errorLevel: ExceptionDisplayLevel;
}

export enum ExceptionDisplayLevel {
    DANGER = 'DANGER',
    WARNING = 'WARNING',
    INFO = 'INFO',
    NONE = 'NONE',
}
